export const LABEL_PREDEFINED_COLORS = [
	'#c69c96',
	'#dd89a6',
	'#adeaf0',
	'#a58dfa',
	'#848fa6',
	'#e69edc',
	'#76d0e4',
	'#78dfb6',
	'#b5eeb3',
	'#bfe66d',
	'#f5e99e',
	'#f0caaa',
	'#adba8c',
	'#ef837d',
	'#97c1e0',
	'#cecece',
	'#efe4d3',
	'#c0e4de',
];

// Fallback tag color for a label with no color set (defensive — labels are created with a color).
export const DEFAULT_LABEL_COLOR = '#bfbfbf';

export const pickRandomLabelColor = (usedColors: string[] = []): string => {
	const usageByColor = new Map<string, number>(
		LABEL_PREDEFINED_COLORS.map((color) => [color, 0] as [string, number])
	);
	usedColors.forEach((usedColor) => {
		if (!usedColor) return;
		const normalized = usedColor.toLowerCase();
		if (usageByColor.has(normalized)) {
			usageByColor.set(normalized, usageByColor.get(normalized) + 1);
		}
	});

	const fewestUses = Math.min(...Array.from(usageByColor.values()));
	const leastUsedColors = LABEL_PREDEFINED_COLORS.filter(
		(color) => usageByColor.get(color) === fewestUses
	);
	return leastUsedColors[Math.floor(Math.random() * leastUsedColors.length)];
};

const hslToHex = (hue: number, saturationPercent: number, lightnessPercent: number): string => {
	const saturation = saturationPercent / 100;
	const lightness = lightnessPercent / 100;
	const chroma = saturation * Math.min(lightness, 1 - lightness);
	const channel = (offset: number): string => {
		const position = (offset + hue / 30) % 12;
		const value = lightness - chroma * Math.max(-1, Math.min(position - 3, 9 - position, 1));
		return Math.round(value * 255)
			.toString(16)
			.padStart(2, '0');
	};
	return `#${channel(0)}${channel(8)}${channel(4)}`;
};

export const generateRandomColor = (): string =>
	hslToHex(
		Math.floor(Math.random() * 360),
		55 + Math.floor(Math.random() * 25),
		38 + Math.floor(Math.random() * 18)
	);

export const generateTempLabelId = (): number => -Date.now();
